import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron",
  "use": "chevron-usage",
  "viewBox": "0 0 14 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 25\" id=\"chevron\"><path fill-rule=\"evenodd\" d=\"m1.42 13.74 8.4 9.53a1.74 1.74 0 1 0 2.61-2.3l-7.38-8.39L8.56 8.6l.76-.85 3.11-3.54a1.74 1.74 0 0 0-2.62-2.3l-8.39 9.53a1.76 1.76 0 0 0 0 2.3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol